/*
    Questo file contiene tutti i parametri globali di configurazione del sito.
    Il file contiene quattro insiemi di parametri, due per la fase di sviluppo (localhost o cartella 
    Montefiorino, con webservice di test basati su A-Way), uno per lo sviluppo con WS Mediatoys e uno 
    per il sito di produzione (con webservice Mediatoys).
    Commentare e scommentare i set di parametri in maniera opportuna, specialmente prima di 
    fare un build.
*/


// 1. parametri di sviluppo localhost + ws mediatoys
const g_cfg = {
  //urlBase: "https://test.montefiorino.com/",
  urlBase: "https://www.bburago-shop.it/",
  urlItemImg: "",
  //urlAddToCart: "cart-api/",    // test site - montefiorino ws only
  //urlWSBase: "https://www.montefiorino.com/DOWNLOADS/PROVE/Mediatoys/", // webservice
  //urlWSBase: "https://test.montefiorino.com/tools/", // webservice
  //urlWSBase: "https://ws.mediatoys.it/",  // webservice

  authMode: 2, // 0: no auth, 1: fetch token (test), 2: token in cookie
  devTools: false, // if true, show react query devtools panel
  debug: false, // if true, shows debug messages on console log

  accessTokenCookieName: "BburagoWebserviceAccess",
  refreshTokenCookieName: "BburagoWebserviceRefresh", // unused
  sessionCookieName: "BburagoWebserviceSession",
  userDataCookieName: "BburagoUserData",
  //doofinderId: "3a3f1b8385324f23d310c10bb5b3fdfe",
  doofinderId: "4ca2aa2ad7705426b5b17b2443709000",  // id ufficiale bburago-shop
  //googleId: "388492032919-ghv4d88oec30m3v3g4ejqe92r9c36pj8.apps.googleusercontent.com",
  googleId: "641052384999-f2r2jci3htm8re66olmra9t9v8gmvvso.apps.googleusercontent.com",  // uffficiale bburago-shop
  //googleMapId: "AIzaSyC_L7Hxe6qAW5a1R7EvX3puy_I6RvHvfX4",
  googleMapId: "AIzaSyAnk8m_01b7wS20YG1QoVG0fddJOzYIwCw",   // ufficiale bburago-shop
  //facebookId: "153870014651629",
  facebookId: "407118780804642",    // ufficiale bburago-shop
  reCaptchaKey: "6Ld618ocAAAAAJEjcw0BbjGzk0s7_9pPmIbAwr7O", // ufficiale bburago-shop

  facebookUrl: "https://www.facebook.com/bburagoitaliaofficial",
  instagramUrl: "https://www.instagram.com/bburagocollezione",
  pinterestUrl: "",
  twitterUrl: "",
  youTubeUrl: "",

  IubendaId: "22997226",
  iubendaPrivacyUrl: "https://www.iubenda.com/privacy-policy/22997226",
  iubendaCookieUrl: "https://www.iubenda.com/privacy-policy/22997226/cookie-policy",
  //iubendaCookieUrl: "https://www.iubenda.com/privacy-policy/22997226/cookie-policy?an=no&s_ck=false&newmarkup=yes",

  cartSilentRegister: true, // se true, la registrazione dell'utente all'invio dell'ordine è automatica
  //mediaClause: "(max-width: 919px)", /* clausola delle media query che discrimina tra desktop mode e mobile mode*/
  mediaClause: "(max-width: 800px)" /* clausola delle media query che discrimina tra desktop mode e mobile mode*/,

  // contacts info
  name: "Mediatoys S.r.l.",
  address: "Via Marsala, 15",
  city: "40126 Bologna (BO)",
  country: "Italy",
  phone: "(+39) 051.231.937",
  mobile: "393.9029091",
  mobileText: "(Sig. Zabban Guido)",
  openingHours: "",

  // site public info
  siteName: "bburago-shop.it",
  siteEmail: "info@bburago-shop.it",

  // url structure (UNUSED - TBD)
  //catalogSlug: "articoli",
  //catalogText: "Articoli",
  catalogSlug: "prodotti",
  catalogText: "Prodotti",

  htmlItemDescr: false,   // se true, la descrizione articolo è in formato Html

  convert(num) {
    return num
      .toFixed(2)
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  },
};

/*
// 4. parametri di build montefiorino + ws montefiorino
const g_cfg = {
    urlBase : "https://www.montefiorino.com/DOWNLOADS/PROVE/Bburago/",
    urlItemImg : "https://www.montefiorino.com/DOWNLOADS/PROVE/Mediatoys/images/Items/sl/",
    urlAddToCart : "cart-api/",

    urlWSBase : "https://www.montefiorino.com/DOWNLOADS/PROVE/Mediatoys/",  // webservice

    convertToSlug: function(text) {
        return Text
        .toLowerCase()
        .replace(/[^\w ]+/g,'')
        .replace(/ +/g,'-')
        ;
    }
}
*/
/*
// 5. parametri di produzione (ws mediatoys)
const g_cfg = {
    urlBase : "https://www.bburago.it/",
    urlItemImg : "https://cdnqualcosa/",
    urlAddToCart : "it/cart-api/",
    urlWSBase : "https://ws.mediatoys.it/",  // webservice

    convertToSlug: function(text) {
        return Text
        .toLowerCase()
        .replace(/[^\w ]+/g,'')
        .replace(/ +/g,'-')
        ;
    }
}
*/

export default g_cfg;